export default {
  header: {
    back: 'back',
    currentPage: 'Page:',
    width: 'width',
    editData: 'Edit Data',
    chinese: '中文',
    english: 'English',
    save: 'Save',
    toPriview: 'Preview',
    toEdit: 'Edit'
  },
  model: {
    addModel: 'Add Component'
  },
  page: {
    setUpPage: 'Pages',
    show: 'Show',
    hide: 'Hide',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    page: 'Page',
    name: 'Page Name',
    path: 'Page Path',
    toIndex: 'Set as Home Page',
    title: 'Page Name',
    onboardingPage: 'This is onboarding questionnaire page, please go to the onboarding management to manage the questionnaires',
    onboardingPageTitle: 'Onboarding',
    satisfactionSurveyPageTitle: 'Satisfaction Survey',
    postApplicantPageTitle: 'Questionnaire'
  },
  component: {
    add: 'Add ',
    edit: 'Edit ',
    component: ' Component'
  },
  theme: {
    setUptheme: 'Color Schema',
    bgColor: 'Background',
    btnColor: 'Button'
  },
  common: {
    edit: 'Edit',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    addComponent: 'Add',
    editComponent: 'Edit',
    component: ' Section'
  },
  promotionLink: {
    menu: 'Promotion Links',
    company: 'Company URL',
    mobileJobList: 'Mobile Job List URL',
    addInTalentPool: 'Add me to talent pool URL',
    copyLink: 'Press Ctrl+C to copy the URL'
  }
}
